<!-- display-desktop-10 preview — a display ad in the right rail of a desktop
     publisher page, on the same stand-in page as the other desktop placements:
     a serif wordmark, a nav row with the site tools opposite it, then the
     article. The article does not run the page's full width here — it keeps its
     column on the left and the ad sits in a rail beside it. The unit is the
     tallest of the rail cards: a full-bleed creative carrying Google's own
     dismiss and AdChoices controls, then the advertiser's mark, a headline set
     large over two lines, a three-line description, the advertiser's name, and
     a call to action alone on a row of its own under a rule. -->
<app-desktop-frame>
  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- The site account button, tight against the top of the window. -->
    <div class="da-account d-flex justify-content-end">
      <i class="bi bi-person-circle" aria-hidden="true"></i>
    </div>

    <!-- The publisher wordmark. A stand-in logo, so it is set as text. -->
    <div class="da-wordmark">website</div>

    <!-- Site nav on the left, site tools on the right. -->
    <div class="da-nav d-flex flex-row align-items-start">
      <span
        *ngFor="let item of navItems"
        class="da-nav-item placeholder"
        aria-hidden="true"
      ></span>

      <div class="da-tools d-flex flex-row align-items-center ms-auto">
        <i class="bi bi-search" aria-hidden="true"></i>
        <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
        <i class="bi bi-share" aria-hidden="true"></i>
        <i class="bi bi-envelope" aria-hidden="true"></i>
        <i class="bi bi-rss" aria-hidden="true"></i>
      </div>
    </div>

    <!-- The article column and the ad rail beside it. -->
    <div class="da-content d-flex flex-row">
      <!-- The article the ad sits beside, and the lead image the window cuts
           off. Same skeleton as the placements that run above the article, just
           in a narrower share of the page. -->
      <div class="da-article">
        <div class="da-bars d-flex flex-column">
          <span
            *ngFor="let bar of bodyBars; let last = last"
            class="da-bar placeholder"
            [class.da-bar-short]="last"
            aria-hidden="true"
          ></span>
        </div>

        <div class="da-block" aria-hidden="true"></div>
      </div>

      <!-- START: Real ad -->
      <div class="da-ad">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
          <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
          <div *ngIf="!creativeImage" class="da-creative-image creative-missing">{{ missingDimensionLabel }}</div>

          <!-- Both badges are chrome the network draws over the unit, so they
               are decorative here. The dismiss control rides straight on the
               creative on a disc of its own, and the AdChoices badge on a white
               tile, so each stays legible whatever the upload puts behind it. -->
          <span
            class="da-dismiss d-flex align-items-center justify-content-center"
          >
            <i class="bi bi-x-lg" aria-hidden="true"></i>
          </span>

          <span
            class="da-adchoices d-flex align-items-center justify-content-center"
          >
            <i class="bi bi-info-circle" aria-hidden="true"></i>
          </span>
        </a>

        <div class="da-card-body">
          <!-- GenSingleImagePreviewData carries no logo field, so the mark is
               the Valamar asset rather than an authored one, the same
               compromise the other placements make. -->
          <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
          <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>

          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
            {{ data.headlines[0] || "Your headline appears here" }}
          </a>

          <div class="da-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>

          <!-- The mock names the advertiser here rather than showing a mark a
               second time. GenSingleImagePreviewData carries no advertiser
               field, so the name is a literal here, the same compromise the
               other placements make. -->
          <div class="da-advertiser">Valamar</div>
        </div>

        <!-- The call to action has a row of its own under the rule, set against
             the right end of it. -->
        <div class="da-footer">
          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta d-inline-flex align-items-center">
            <span class="da-cta-label">
              {{ data.ctaText || "Your call to action" }}
            </span>
            <i class="bi bi-chevron-right" aria-hidden="true"></i>
          </a>
        </div>
      </div>
      <!-- END: Real ad -->
    </div>
  </div>
  <!-- END: Publisher page -->
</app-desktop-frame>
